"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSliderThumb = void 0;
var _SliderThumb = require("./SliderThumb");
// TODO: in v9, move styled() from SliderThumb.jsx to here
var StyledSliderThumb = _SliderThumb.SliderThumb;
exports.StyledSliderThumb = StyledSliderThumb;